import * as React from 'react'; 
import {useState} from 'react';
import { SurveyForm } from '../SurveyForm';
import "../Styles/SurveyForm.css";
import { SurveyFormCredir } from './SurveyFormCredir';
import { ConfirmCode } from '../VerifyComponents/ConfirmCode';
import { ModalVerify } from '../VerifyComponents/ModalVerify';
import axios from 'axios';

interface Props {
    survey: any;
    loading: boolean;
    user: any;
    passPortal: () => any;
    postAnwers: (survey) => any;
    ap: any;
    device_id: string;
    campaign: any;
    postImpression: (media: string) => any;
}   

const CreditSurvey: React.FC<Props> = ({survey, loading, user, passPortal, ap, device_id, postAnwers,campaign, postImpression }) => {
    const [surve, setSurve] = useState(survey);

    const [load, setLoad] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [valid, setValid] = useState(false);
    const [phoneNumber, setphoneNumber] = useState("");
    const [codesetn, setCodeSent] = useState(false);
    const [error, setError] = useState(null);
    
    const handlerChange = (question, value) => {
        let q = survey.questions.find(v => v.id === question.id);
        q.answer = value;
        setSurve({...survey});
    }

    const setAnswers_ = async() => {
        try {
          console.log("hey")
            let respu = surve.questions.find(q => {
                let question: string = q.question.toLowerCase();
                return question.includes("telefono") || question.includes("celular")
            });
            setphoneNumber(respu.answer);
            sentSMS(respu.answer);
        } catch (error) {
            console.log(error);
        }
    }

   
    const sentSMS = async (phone) => {
      try {
        let res = await axios.get("/sms", {
          params: {
            phoneNumber: phone,
          },
        });
        console.log(res.data);
        setCodeSent(true);
      } catch (err) {
        setCodeSent(false);
      }
    };

    const confirm = async (value, code) => {
        setLoad(true);
        setShowModal(true);
        try {
          let resp = await axios.post("/userReg", {
            fields: {
              ap_mac: ap.ap_mac,
              device_id,
              verify: "sms",
              phoneNumber: value,
              code
            },
          });
          setLoad(false);
          if (resp.data.error) {
            setValid(false);
          } else {
            setValid(true);
            postAnwers(surve);
          }
        } catch (error) {
          console.error(error);
          setValid(false);
          setShowModal(false);
          setLoad(false);

        }
      };

    const callToAction = async() => {
      try {
        await postImpression('call');
        window.open(`tel:${campaign.contact_phone}`, '_self');
      } catch (error) {
        console.log(error);
      }
    }

    const noThanks = async() => {
      try {
        await postImpression('nogracias');
        passPortal();
      } catch (error) {
        console.log(error);
      }
    }

    return (
        <div className="SurveyContainer animated fadeIn">
            {
                codesetn && (
                
                  <ConfirmCode
                  confirm={confirm}
                  phoneNumber={phoneNumber}
                  close={() => setCodeSent(false)}
                  performance={true}
                />
                )
            }
             <ModalVerify
                show={showModal}
                message=""
                valid={valid}
                loading={load}
                closeModal={() => setShowModal(false)}
                passPortal={() => {
                setShowModal(false)
                }}
            />
        <div className="SurveyHeader">
            <h4>{survey && survey.survey_name}</h4>
            <small>{survey && survey.description}</small>
        </div>
        <div>
            {loading ? <div>...</div> : 
            
            <SurveyFormCredir
                questions={survey ? survey.questions : []} 
                handlerChange={(question, value) => handlerChange(question, value)}
                submitAnswers={() => setAnswers_()}
                noThanks={() =>  noThanks()}
                politicView={() => postImpression('politica') }
                campaign={campaign}
                callToAction={() => callToAction()}
                /> 
            }
        </div>
    </div>
    )
}

export default CreditSurvey
